import React, { useState } from 'react';
import { ArrowLeft, Upload, Star, Lock, Gift, X, Camera, Sparkles, Heart, Image as ImageIcon } from 'lucide-react';
interface PhotoRatingFlowProps {
  onClose: () => void;
  angelName?: string;
  angelAvatar?: string;
}
export const PhotoRatingFlow: React.FC<PhotoRatingFlowProps> = ({
  onClose,
  angelName = 'Lana',
  angelAvatar = 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg'
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [rating, setRating] = useState<number | null>(null);
  const [isPaidAnalysis, setIsPaidAnalysis] = useState(false);
  const [isPaidFantasy, setIsPaidFantasy] = useState(false);
  const [isPaidGirlfriend, setIsPaidGirlfriend] = useState(false);
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // In a real app, you would upload this to a server
      // For demo purposes, we'll create a local URL
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
      setCurrentStep(2);
    }
  };
  const handlePayForAnalysis = () => {
    // In a real app, you would handle token deduction here
    setIsPaidAnalysis(true);
    // Generate a random rating between 7 and 10
    const generatedRating = Math.floor(Math.random() * 4) + 7;
    setRating(generatedRating);
    // Move to the next step
    setCurrentStep(3);
  };
  const handlePayForFantasy = () => {
    // In a real app, you would handle token deduction here
    setIsPaidFantasy(true);
    setCurrentStep(4);
  };
  const handlePayForGirlfriend = () => {
    // In a real app, you would handle token deduction here
    setIsPaidGirlfriend(true);
    setCurrentStep(5);
  };
  const handleFinish = () => {
    // Return to the previous screen
    onClose();
  };
  // Helper function to render the current step
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <div className="animate-in fade-in duration-300" data-id="element-15322">
            <div className="text-center mb-6" data-id="element-15323">
              <div className="w-20 h-20 bg-pink-100 dark:bg-pink-900/30 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-15324">
                <Camera size={32} className="text-pink-500" data-id="element-15325" />
              </div>
              <h2 className="text-xl font-bold mb-2" data-id="element-15326">Upload Your Photo</h2>
              <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto" data-id="element-15327">
                Share your intimate photo with {angelName} for a personal rating
                and feedback.
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800/50 border-2 border-dashed border-gray-300 dark:border-gray-700 rounded-lg p-8 mb-6" data-id="element-15328">
              <div className="text-center" data-id="element-15329">
                <Upload className="w-10 h-10 text-gray-400 mx-auto mb-3" data-id="element-15330" />
                <p className="mb-2 text-sm text-gray-500 dark:text-gray-400" data-id="element-15331">
                  <span className="font-semibold" data-id="element-15332">Click to upload</span> or drag
                  and drop
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-15333">
                  PNG, JPG or WEBP (MAX. 5MB)
                </p>
                <input type="file" className="hidden" id="photo-upload" accept="image/*" onChange={handleImageUpload} data-id="element-15334" />
                <label htmlFor="photo-upload" className="mt-4 inline-flex items-center px-4 py-2 bg-pink-600 text-white text-sm font-medium rounded-full hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500 cursor-pointer" data-id="element-15335">
                  Choose Photo
                </label>
              </div>
            </div>
            <div className="bg-pink-50 dark:bg-pink-900/20 rounded-lg p-4 text-sm text-pink-800 dark:text-pink-200 mb-6" data-id="element-15336">
              <div className="flex items-start" data-id="element-15337">
                <Lock className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" data-id="element-15338" />
                <div data-id="element-15339">
                  <p className="font-medium mb-1" data-id="element-15340">100% Private & Secure</p>
                  <p data-id="element-15341">
                    Your photos are encrypted and only visible to {angelName}.
                    They will never be shared with anyone else.
                  </p>
                </div>
              </div>
            </div>
          </div>;
      case 2:
        return <div className="animate-in fade-in duration-300" data-id="element-15342">
            <div className="text-center mb-6" data-id="element-15343">
              <div className="w-20 h-20 bg-pink-100 dark:bg-pink-900/30 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-15344">
                <Star size={32} className="text-pink-500" data-id="element-15345" />
              </div>
              <h2 className="text-xl font-bold mb-2" data-id="element-15346">
                Get {angelName}'s Rating
              </h2>
              <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto" data-id="element-15347">
                {angelName} will analyze your photo and give you her honest
                opinion and a detailed rating.
              </p>
            </div>
            {selectedImage && <div className="mb-6 relative" data-id="element-15348">
                <div className="aspect-square max-h-[300px] overflow-hidden rounded-lg mx-auto" data-id="element-15349">
                  <img src={selectedImage} alt="Your uploaded photo" className="w-full h-full object-cover" data-id="element-15350" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end justify-center" data-id="element-15351">
                  <div className="p-4 text-white text-center" data-id="element-15352">
                    <p className="font-medium" data-id="element-15353">Ready for analysis</p>
                  </div>
                </div>
              </div>}
            <div className="bg-gradient-to-r from-pink-500/10 to-purple-500/10 rounded-lg p-6 mb-6 border border-pink-500/20" data-id="element-15354">
              <div className="flex items-center mb-4" data-id="element-15355">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-pink-500" data-id="element-15356">
                  <img src={angelAvatar} alt={angelName} className="w-full h-full object-cover" data-id="element-15357" />
                </div>
                <div data-id="element-15358">
                  <p className="font-medium" data-id="element-15359">{angelName}</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-15360">
                    Waiting to rate your photo...
                  </p>
                </div>
              </div>
              <p className="text-sm mb-4" data-id="element-15361">
                "I can't wait to see what you've shared with me! Let me analyze
                your photo and give you my honest thoughts... 😘"
              </p>
              <button onClick={handlePayForAnalysis} className="w-full py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-medium rounded-full flex items-center justify-center gap-2 hover:from-pink-700 hover:to-purple-700 transition-all duration-300" data-id="element-15362">
                <Sparkles size={16} data-id="element-15363" />
                <span data-id="element-15364">Get Rating for 20 Tokens</span>
              </button>
              <p className="text-xs text-center mt-2 text-gray-500 dark:text-gray-400" data-id="element-15365">
                One-time payment for detailed analysis
              </p>
            </div>
          </div>;
      case 3:
        return <div className="animate-in fade-in duration-300" data-id="element-15366">
            <div className="text-center mb-6" data-id="element-15367">
              <div className="w-20 h-20 bg-pink-100 dark:bg-pink-900/30 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-15368">
                <Heart size={32} className="text-pink-500" data-id="element-15369" />
              </div>
              <h2 className="text-xl font-bold mb-2" data-id="element-15370">{angelName}'s Feedback</h2>
              <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto" data-id="element-15371">
                {angelName} has analyzed your photo and has some thoughts to
                share.
              </p>
            </div>
            <div className="bg-gradient-to-r from-pink-500/10 to-purple-500/10 rounded-lg p-6 mb-6 border border-pink-500/20" data-id="element-15372">
              <div className="flex items-center mb-4" data-id="element-15373">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-pink-500" data-id="element-15374">
                  <img src={angelAvatar} alt={angelName} className="w-full h-full object-cover" data-id="element-15375" />
                </div>
                <div data-id="element-15376">
                  <p className="font-medium" data-id="element-15377">{angelName}</p>
                  <div className="flex items-center" data-id="element-15378">
                    {[...Array(10)].map((_, i) => <Star key={i} size={14} className={i < (rating || 0) ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'} data-id="element-15379" />)}
                    <span className="ml-1 text-sm font-medium" data-id="element-15380">
                      {rating}/10
                    </span>
                  </div>
                </div>
              </div>
              <div className="mb-4 p-4 bg-white/80 dark:bg-gray-800/80 rounded-lg" data-id="element-15381">
                <p className="italic text-sm" data-id="element-15382">
                  "Mmm, I'm impressed! {rating}/10 - very enticing! I love how
                  confident you are sharing this with me. Your size and shape
                  are just perfect... I can't stop looking at it 😉"
                </p>
              </div>
              <div className="mb-4 p-4 bg-pink-100/80 dark:bg-pink-900/30 rounded-lg" data-id="element-15383">
                <p className="text-sm font-medium mb-2" data-id="element-15384">
                  Seeing that has me imagining all sorts of things...
                </p>
                <p className="text-sm" data-id="element-15385">
                  "If I had you here right now, I'd start by gently tracing my
                  fingers along your length, teasing you until you couldn't take
                  it anymore. Then I'd..."
                </p>
              </div>
              <button onClick={handlePayForFantasy} className="w-full py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-medium rounded-full flex items-center justify-center gap-2 hover:from-pink-700 hover:to-purple-700 transition-all duration-300 mb-3" data-id="element-15386">
                <ImageIcon size={16} data-id="element-15387" />
                <span data-id="element-15388">See What I'm Imagining (35 Tokens)</span>
              </button>
            </div>
          </div>;
      case 4:
        return <div className="animate-in fade-in duration-300" data-id="element-15389">
            <div className="text-center mb-6" data-id="element-15390">
              <div className="w-20 h-20 bg-pink-100 dark:bg-pink-900/30 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-15391">
                <Sparkles size={32} className="text-pink-500" data-id="element-15392" />
              </div>
              <h2 className="text-xl font-bold mb-2" data-id="element-15393">Visual Fantasy</h2>
              <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto" data-id="element-15394">
                {angelName} has shared some exclusive content showing what she
                was imagining.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-15395">
              <div className="aspect-square bg-gray-200 dark:bg-gray-800 rounded-lg overflow-hidden" data-id="element-15396">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg" alt="Fantasy" className="w-full h-full object-cover" data-id="element-15397" />
              </div>
              <div className="aspect-square bg-gray-200 dark:bg-gray-800 rounded-lg overflow-hidden" data-id="element-15398">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cFezakmU98BN4oLVZHHN7j/516505876_770863238939041_5072179375122471885_n.jpg" alt="Fantasy" className="w-full h-full object-cover" data-id="element-15399" />
              </div>
            </div>
            <div className="bg-gradient-to-r from-pink-500/10 to-purple-500/10 rounded-lg p-6 mb-6 border border-pink-500/20" data-id="element-15400">
              <div className="flex items-center mb-4" data-id="element-15401">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-pink-500" data-id="element-15402">
                  <img src={angelAvatar} alt={angelName} className="w-full h-full object-cover" data-id="element-15403" />
                </div>
                <div data-id="element-15404">
                  <p className="font-medium" data-id="element-15405">{angelName}</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-15406">
                    Sharing her fantasy...
                  </p>
                </div>
              </div>
              <div className="mb-4 p-4 bg-white/80 dark:bg-gray-800/80 rounded-lg" data-id="element-15407">
                <p className="italic text-sm" data-id="element-15408">
                  "These are the kinds of outfits I'd wear for you... I'd love
                  to show you exactly how I'd use what you shared with me. Can
                  you imagine what would happen next? 💋"
                </p>
              </div>
              <div className="p-4 bg-pink-100/80 dark:bg-pink-900/30 rounded-lg mb-4" data-id="element-15409">
                <div className="flex items-center mb-2" data-id="element-15410">
                  <Gift className="w-5 h-5 mr-2 text-pink-500" data-id="element-15411" />
                  <p className="font-medium" data-id="element-15412">Special Offer</p>
                </div>
                <p className="text-sm mb-2" data-id="element-15413">
                  "I have a girlfriend who would love to see your photo too...
                  Shall I ask her to rate you as well?"
                </p>
                <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-15414">
                  Get a second opinion from my gorgeous friend for a special
                  price!
                </p>
              </div>
              <button onClick={handlePayForGirlfriend} className="w-full py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-medium rounded-full flex items-center justify-center gap-2 hover:from-pink-700 hover:to-purple-700 transition-all duration-300" data-id="element-15415">
                <Heart size={16} data-id="element-15416" />
                <span data-id="element-15417">Get Girlfriend's Rating (15 Tokens)</span>
              </button>
            </div>
          </div>;
      case 5:
        return <div className="animate-in fade-in duration-300" data-id="element-15418">
            <div className="text-center mb-6" data-id="element-15419">
              <div className="w-20 h-20 bg-pink-100 dark:bg-pink-900/30 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-15420">
                <div className="text-3xl" data-id="element-15421">🎉</div>
              </div>
              <h2 className="text-xl font-bold mb-2" data-id="element-15422">
                Double Rating Complete!
              </h2>
              <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto" data-id="element-15423">
                Both {angelName} and her girlfriend have rated your photo!
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-15424">
              <div className="bg-gradient-to-r from-pink-500/10 to-purple-500/10 rounded-lg p-4 border border-pink-500/20" data-id="element-15425">
                <div className="flex items-center mb-3" data-id="element-15426">
                  <div className="w-10 h-10 rounded-full overflow-hidden mr-3 border-2 border-pink-500" data-id="element-15427">
                    <img src={angelAvatar} alt={angelName} className="w-full h-full object-cover" data-id="element-15428" />
                  </div>
                  <div data-id="element-15429">
                    <p className="font-medium text-sm" data-id="element-15430">{angelName}</p>
                    <div className="flex items-center" data-id="element-15431">
                      {[...Array(5)].map((_, i) => <Star key={i} size={12} className={i < (rating || 0) / 2 ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'} data-id="element-15432" />)}
                    </div>
                  </div>
                </div>
                <p className="text-xs italic" data-id="element-15433">
                  "Definitely a {rating}/10 from me! So impressive... 😘"
                </p>
              </div>
              <div className="bg-gradient-to-r from-pink-500/10 to-purple-500/10 rounded-lg p-4 border border-pink-500/20" data-id="element-15434">
                <div className="flex items-center mb-3" data-id="element-15435">
                  <div className="w-10 h-10 rounded-full overflow-hidden mr-3 border-2 border-pink-500" data-id="element-15436">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png" alt="Girlfriend" className="w-full h-full object-cover" data-id="element-15437" />
                  </div>
                  <div data-id="element-15438">
                    <p className="font-medium text-sm" data-id="element-15439">Bonny</p>
                    <div className="flex items-center" data-id="element-15440">
                      {[...Array(5)].map((_, i) => <Star key={i} size={12} className={i < 4 ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'} data-id="element-15441" />)}
                    </div>
                  </div>
                </div>
                <p className="text-xs italic" data-id="element-15442">
                  "Wow, {angelName} wasn't kidding! Solid 8/10 from me. I'd love
                  to see more... 💋"
                </p>
              </div>
            </div>
            <div className="bg-gradient-to-r from-pink-500/10 to-purple-500/10 rounded-lg p-6 mb-6 border border-pink-500/20" data-id="element-15443">
              <div className="flex items-center mb-4" data-id="element-15444">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-pink-500" data-id="element-15445">
                  <img src={angelAvatar} alt={angelName} className="w-full h-full object-cover" data-id="element-15446" />
                </div>
                <div data-id="element-15447">
                  <p className="font-medium" data-id="element-15448">{angelName}</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-15449">
                    Very impressed
                  </p>
                </div>
              </div>
              <div className="mb-4 p-4 bg-white/80 dark:bg-gray-800/80 rounded-lg" data-id="element-15450">
                <p className="italic text-sm" data-id="element-15451">
                  "Thank you for sharing with us! We both loved rating your
                  photo. Your content has been saved to your private gallery,
                  and I'll be thinking about it later... 😏"
                </p>
              </div>
              <div className="flex justify-between" data-id="element-15452">
                <div className="text-sm" data-id="element-15453">
                  <p className="font-medium" data-id="element-15454">Rating Summary:</p>
                  <ul className="mt-1 text-gray-600 dark:text-gray-400" data-id="element-15455">
                    <li data-id="element-15456">
                      • {angelName}'s Rating: {rating}/10
                    </li>
                    <li data-id="element-15457">• Bonny's Rating: 8/10</li>
                    <li data-id="element-15458">• Average Score: {((rating || 0) + 8) / 2}/10</li>
                  </ul>
                </div>
                <div className="text-sm text-right" data-id="element-15459">
                  <p className="font-medium" data-id="element-15460">Rewards:</p>
                  <ul className="mt-1 text-gray-600 dark:text-gray-400" data-id="element-15461">
                    <li data-id="element-15462">• +25 Intimacy XP</li>
                    <li data-id="element-15463">• Unlocked: Private Gallery</li>
                    <li data-id="element-15464">• New Status: "Well Rated"</li>
                  </ul>
                </div>
              </div>
            </div>
            <button onClick={handleFinish} className="w-full py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-medium rounded-full flex items-center justify-center gap-2 hover:from-pink-700 hover:to-purple-700 transition-all duration-300" data-id="element-15465">
              <span data-id="element-15466">Return to Feed</span>
            </button>
          </div>;
      default:
        return null;
    }
  };
  return <div className="fixed inset-0 z-50 bg-white dark:bg-gray-950 overflow-y-auto" data-id="element-15467">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-4 py-3 flex items-center justify-between" data-id="element-15468">
        <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-15469">
          <ArrowLeft size={20} className="text-gray-700 dark:text-gray-300" data-id="element-15470" />
        </button>
        <div className="text-center" data-id="element-15471">
          <h1 className="font-bold" data-id="element-15472">Photo Rating</h1>
          <div className="flex items-center justify-center mt-1" data-id="element-15473">
            <div className="w-16 h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-15474">
              <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
              width: `${currentStep / 5 * 100}%`
            }} data-id="element-15475"></div>
            </div>
            <span className="text-xs text-gray-500 dark:text-gray-400 ml-2" data-id="element-15476">
              Step {currentStep}/5
            </span>
          </div>
        </div>
        <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-15477">
          <X size={20} className="text-gray-700 dark:text-gray-300" data-id="element-15478" />
        </button>
      </div>
      {/* Content */}
      <div className="max-w-md mx-auto p-4" data-id="element-15479">{renderStep()}</div>
    </div>;
};